<template>
  <div>
    <v-app-bar
      height="80px"
      color="transparent"
      flat
      light
      app
      class="modern-app-bar"
    >
      <div class="floating-header-inner">
        <!-- Mobile navigation drawer toggle -->
        <v-btn
          icon
          class="hidden-lg-and-up mobile-toggle-btn mr-2"
          @click="$emit('toggle-sidebar')"
        >
          <v-icon color="#2e9e60">mdi-menu</v-icon>
        </v-btn>

        <!-- Brand / Logo Area with Glass/Glow Effect -->
        <div class="brand-wrapper">
          <div class="logo-glow-ring">
            <v-img
              src="./../../assets/images/newlogo.png"
              height="44px"
              width="44px"
              contain
              class="logo-img"
            ></v-img>
          </div>
          <div class="brand-text-container ml-3 hidden-xs-only">
            <span class="brand-title">KL06</span>
          </div>
        </div>

        <v-spacer></v-spacer>

        <!-- Right Action Controls -->
        <div class="header-actions">

          <!-- Notification Bell with pulsing animation -->
          <router-link to="/Notification" class="text-decoration-none">
            <v-btn icon class="action-btn mx-1">
              <v-badge
                color="#ff4757"
                class="notification-badge"
                :content="notificationCount ? notificationCount : '0'"
                overlap
                small
              >
                <v-icon color="#2e9e60" size="22">mdi-bell-outline</v-icon>
              </v-badge>
            </v-btn>
          </router-link>

          <!-- Vertical Separator -->
          <div class="action-separator mx-2"></div>

          <!-- Custom User Profile Chip -->
          <AccountMenu />
        </div>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import axios from "axios";
import AccountMenu from "./accountMenu.vue";

export default {
  components: {
    AccountMenu,
  },
  data() {
    return {
      notificationCount: 0,
    };
  },
  mounted() {
    this.getNotificationCount();
    this.$root.$on('notification-deleted', () => {
      this.getNotificationCount();
    });
  },
  beforeDestroy() {
    this.$root.$off('notification-deleted');
  },
  methods: {
    getNotificationCount() {
      axios({
        method: "GET",
        url: "/dashboard/admin",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.notificationCount = response.data.unreadNotificationCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.modern-app-bar {
  z-index: 15 !important;
}

/* Deep override to remove absolute header positioning issues */
::v-deep .v-toolbar__content {
  padding: 0 !important;
}

.floating-header-inner {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0 20px;
  display: flex;
  align-items: center;
  background: #cbeedb;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid #a8e2c3;
  border-radius: 0;
  box-shadow: 0 10px 25px -5px rgba(46, 158, 96, 0.07), 0 4px 12px -2px rgba(0, 0, 0, 0.02);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.floating-header-inner:hover {
  box-shadow: 0 12px 30px -5px rgba(46, 158, 96, 0.1), 0 6px 16px -2px rgba(0, 0, 0, 0.03);
  border-color: rgba(46, 158, 96, 0.4);
}

.mobile-toggle-btn {
  background-color: #ffffff;
  border: 1px solid #a8e2c3;
}

.brand-wrapper {
  display: flex;
  align-items: center;
}

.logo-glow-ring {
  padding: 3px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #a8e2c3;
  box-shadow: 0 4px 10px rgba(46, 158, 96, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.logo-glow-ring:hover {
  transform: scale(1.08) rotate(8deg);
  box-shadow: 0 6px 15px rgba(46, 158, 96, 0.12);
}

.brand-text-container {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.brand-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  font-size: 16px;
  color: #1e293b;
  letter-spacing: 0.8px;
}

.brand-badge {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 9px;
  color: #2e9e60;
  background-color: #e8f7ee;
  padding: 2px 6px;
  border-radius: 6px;
  margin-top: 2px;
  width: fit-content;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.search-bar-container {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  padding: 0 12px;
  height: 38px;
  width: 240px;
  transition: all 0.2s ease;
}

.search-bar-container:focus-within {
  border-color: #2e9e60;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(46, 158, 96, 0.08);
  width: 270px;
}

.search-input {
  border: none;
  background: transparent;
  outline: none;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: #334155;
  width: 100%;
  margin-left: 8px;
}

.search-input::placeholder {
  color: #94a3b8;
  font-weight: 500;
}

.search-shortcut {
  font-size: 10px;
  font-weight: 600;
  color: #94a3b8;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 1px 4px;
  user-select: none;
}

.search-bar-container:focus-within .search-shortcut {
  display: none;
}

.header-actions {
  display: flex;
  align-items: center;
}

.status-indicator-pill {
  display: flex;
  align-items: center;
  background-color: #f0fdf4;
  border: 1px solid #dcfce7;
  padding: 4px 10px;
  border-radius: 20px;
  gap: 6px;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #22c55e;
  position: relative;
}

.status-dot::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #22c55e;
  border-radius: 50%;
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
}

.status-text {
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #15803d;
}

.action-btn {
  background-color: #ffffff;
  border: 1px solid #a8e2c3;
  border-radius: 12px;
  width: 38px;
  height: 38px;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background-color: #e8f7ee;
  border-color: #2e9e60;
  transform: translateY(-1px);
}

.action-separator {
  width: 1px;
  height: 20px;
  background-color: #a8e2c3;
}

::v-deep .v-badge__badge {
  font-size: 9px;
  font-weight: 700;
  height: 17px;
  min-width: 17px;
  padding: 3px;
  border: 2px solid #ffffff;
}
</style>
